import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EventAvailableIcon from '@/assets/icons/event-available-white.svg?react';
import { Header } from './Header';
import { redirectToCenterHome } from '@/utils/navigation';
import './ReservationComplete.scss';

interface ReservationCompleteProps {
    title: string;
    description: React.ReactNode;
    instruction: React.ReactNode;
    onMain?: () => void;
    onLogout?: () => void;
    autoLogoutSeconds?: number;
}

export const ReservationComplete: React.FC<ReservationCompleteProps> = ({
    title,
    description,
    instruction,
    onMain,
    onLogout,
    autoLogoutSeconds = 10,
}) => {
    const [timeLeft, setTimeLeft] = useState(autoLogoutSeconds);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (timeLeft <= 0) {
            if (onLogout) {
                onLogout();
            } else {
                handleLogout();
            }
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft, onLogout]);

    const handleMain = () => {
        if (onMain) {
            onMain();
        } else {
            navigate('/selection');
        }
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        } else {
            redirectToCenterHome();
        }
    };

    return (
        <div className={`reservation-complete ${isMobile ? 'reservation-complete--mobile' : ''}`}>
            <Header />
            <div className="reservation-complete__content">
                <div className="reservation-complete__card">
                    <div className="reservation-complete__icon-wrapper">
                        <EventAvailableIcon className="icon-svg" />
                    </div>
                    <h1 className="reservation-complete__title">{title}</h1>
                    <div className="reservation-complete__details">
                        {description}
                    </div>
                    <div className="reservation-complete__instruction-box">
                        <p>{instruction}</p>
                    </div>
                    <div className="reservation-complete__timer">
                        {timeLeft}초 뒤 자동으로 로그아웃 됩니다.
                    </div>
                    <div className="reservation-complete__actions">
                        <button
                            className="reservation-complete__btn reservation-complete__btn--primary"
                            onClick={handleMain}
                        >
                            메인으로
                        </button>
                        <button
                            className="reservation-complete__btn reservation-complete__btn--secondary"
                            onClick={handleLogout}
                        >
                            즉시 로그아웃
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
